(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-article"] && !Shopify.designMode) return;
  try {
    
class PressArticleScrollbar {
  static TRACK_HEIGHT = 442;
  static THUMB_HEIGHT = 81;

  constructor(root) {
    this.root = root;
    this.content = root.querySelector('[data-press-article-content]');
    this.track = root.querySelector('[data-press-article-scrollbar]');
    this.thumb = root.querySelector('[data-press-article-scrollbar-thumb]');
    this.mediaQuery = window.matchMedia('(min-width: 990px)');

    if (!this.content || !this.track || !this.thumb) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.onTrackClick = this.onTrackClick.bind(this);
    this.onThumbPointerDown = this.onThumbPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);

    this.content.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onResize, { once: true });
    this.mediaQuery.addEventListener('change', this.onMediaChange);
    this.track.addEventListener('click', this.onTrackClick);
    this.thumb.addEventListener('pointerdown', this.onThumbPointerDown);

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.content);
    this.resizeObserver.observe(this.track);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.update());
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.update());
    });
  }

  isActive() {
    return this.mediaQuery.matches;
  }

  getViewportHeight() {
    const clientHeight = this.content.clientHeight;

    if (clientHeight > 0) return clientHeight;

    return PressArticleScrollbar.TRACK_HEIGHT;
  }

  getTrackHeight() {
    const trackHeight = this.track.clientHeight;

    if (trackHeight > 0) return trackHeight;

    return PressArticleScrollbar.TRACK_HEIGHT;
  }

  update() {
    if (!this.isActive()) {
      this.track.hidden = true;
      return;
    }

    const viewportHeight = this.getViewportHeight();
    const { scrollHeight, scrollTop } = this.content;
    const trackHeight = this.getTrackHeight();
    const thumbHeight = PressArticleScrollbar.THUMB_HEIGHT;

    if (scrollHeight <= viewportHeight + 1) {
      this.track.hidden = true;
      return;
    }

    this.track.hidden = false;

    const maxScroll = scrollHeight - viewportHeight;
    const maxThumbTop = trackHeight - thumbHeight;
    const thumbTop = maxScroll > 0 ? (scrollTop / maxScroll) * maxThumbTop : 0;

    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }

  onScroll() {
    if (!this.isDragging) this.update();
  }

  onResize() {
    this.update();
  }

  onMediaChange() {
    this.update();
  }

  onTrackClick(event) {
    if (!this.isActive() || event.target === this.thumb) return;

    const trackRect = this.track.getBoundingClientRect();
    const clickOffset = event.clientY - trackRect.top;
    const viewportHeight = this.getViewportHeight();
    const { scrollHeight } = this.content;
    const trackHeight = this.getTrackHeight();
    const thumbHeight = PressArticleScrollbar.THUMB_HEIGHT;
    const maxScroll = scrollHeight - viewportHeight;
    const maxThumbTop = trackHeight - thumbHeight;
    const targetThumbTop = Math.min(Math.max(clickOffset - thumbHeight / 2, 0), maxThumbTop);

    this.content.scrollTop = maxThumbTop > 0 ? (targetThumbTop / maxThumbTop) * maxScroll : 0;
    this.update();
  }

  onThumbPointerDown(event) {
    if (!this.isActive()) return;

    event.preventDefault();
    this.isDragging = true;
    this.dragStartY = event.clientY;
    this.dragStartScrollTop = this.content.scrollTop;

    this.thumb.setPointerCapture(event.pointerId);
    this.thumb.addEventListener('pointermove', this.onPointerMove);
    this.thumb.addEventListener('pointerup', this.onPointerUp);
    this.thumb.addEventListener('pointercancel', this.onPointerUp);
  }

  onPointerMove(event) {
    if (!this.isDragging) return;

    const viewportHeight = this.getViewportHeight();
    const { scrollHeight } = this.content;
    const trackHeight = this.getTrackHeight();
    const thumbHeight = PressArticleScrollbar.THUMB_HEIGHT;
    const maxScroll = scrollHeight - viewportHeight;
    const maxThumbTop = trackHeight - thumbHeight;
    const deltaY = event.clientY - this.dragStartY;
    const scrollDelta = maxThumbTop > 0 ? (deltaY / maxThumbTop) * maxScroll : 0;

    this.content.scrollTop = this.dragStartScrollTop + scrollDelta;
    this.update();
  }

  onPointerUp(event) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.thumb.releasePointerCapture(event.pointerId);
    this.thumb.removeEventListener('pointermove', this.onPointerMove);
    this.thumb.removeEventListener('pointerup', this.onPointerUp);
    this.thumb.removeEventListener('pointercancel', this.onPointerUp);
  }
}

function initPressArticleScrollbars() {
  document.querySelectorAll('.press-article-main:not(.scrollbar-initialized)').forEach((root) => {
    root.classList.add('scrollbar-initialized');
    new PressArticleScrollbar(root);
  });
}

document.addEventListener('DOMContentLoaded', initPressArticleScrollbars);
document.addEventListener('shopify:section:load', initPressArticleScrollbars);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
class PressLoadMore {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('.press-grid');
    this.button = root.querySelector('[data-press-load-more]');

    if (!this.button || !this.grid) return;

    this.button.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();

    if (this.button.classList.contains('loading')) return;

    const sectionId = this.root.dataset.sectionId;
    const fetchUrl = new URL(this.button.href, window.location.origin);
    fetchUrl.searchParams.set('sections', sectionId);

    this.button.classList.add('loading');

    try {
      const response = await fetch(fetchUrl.toString());
      const data = await response.json();
      const html = data[sectionId];

      if (!html) return;

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const newRoot = template.content.querySelector(`[data-section-id="${sectionId}"]`);

      if (!newRoot) return;

      newRoot.querySelectorAll('.press-article').forEach((article) => {
        this.grid.appendChild(article);
      });

      const newButton = newRoot.querySelector('[data-press-load-more]');

      if (newButton) {
        this.button.href = newButton.href;
      } else {
        this.button.closest('.press-load-more')?.remove();
      }

      if (window.Barracuda) {
        Barracuda.init();
        Barracuda.elements?.init();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.button.classList.remove('loading');
    }
  }
}

function initPressSections() {
  document.querySelectorAll('.press-pagination:not(.initialized)').forEach((root) => {
    root.classList.add('initialized');
    new PressLoadMore(root);
  });
}

document.addEventListener('DOMContentLoaded', initPressSections);
document.addEventListener('shopify:section:load', initPressSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-text"] && !Shopify.designMode) return;
  try {
    
class SeoText {
  constructor(container) {
    this.container = container;
    this.grid = container.querySelector('.seo-text__grid');
    this.mobileButton = container.querySelector('[data-action="mobile-toggle"]');
    this.desktopButton = container.querySelector('[data-action="desktop-toggle"]');
    
    this.init();
  }

  init() {
    if (this.mobileButton) {
      this.mobileButton.addEventListener('click', () => {
        this.grid.classList.toggle('mobile-expanded');
        this.mobileButton.classList.toggle('is-active');
      });
    }

    if (this.desktopButton) {
      this.desktopButton.addEventListener('click', () => {
        this.grid.classList.toggle('desktop-expanded');
        this.desktopButton.classList.toggle('is-active');
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.seo-text');
  sections.forEach(section => new SeoText(section));
});

  } catch(e) { console.error(e); }
})();
})();
